angular.module('unica_tools.tools_controllers')

.controller('ToolsListController', function(
	$rootScope, $scope, $state
) {

})

;